import React, { Component } from 'react';
import { MLOpsDatasourceSchema } from '../../../../domain/mlops/MLOpsSchemaDomains';
import MLOpsDatasourceHistoricalComponent from './MLOpsDatasourceHistoricalComponent';
import MLOpsDatasourceFileComponent from './MLOpsDatasourceFileComponent';
import { MLOpsDatasourceFile, MLOpsDatasourceHistorical } from '../../../../domain/mlops/MLOpsDomains';
import { RadioButton } from 'primereact/radiobutton';
import { RootState } from '../../../../redux/store';
import { AiModelState } from '../../../../redux/reducers/AiModelReducer';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import { PageState } from '../../../../redux/reducers/PageReducer';
import { changePageFilters } from '../../../../redux/actions/PageActions';
import ValueFactory from '../../../../util/ValueFactory';
import LanguageUtil from '../../../../util/LanguageUtil';

class MlOpsDatasourceComponent extends Component<Props> {
  public render() {
    const { datasource, onChange, type } = this.props;
    return (
      <div className='flex flex-col w-full h-full gap-[8px]'>
        <div className='flex w-full h-full justify-between items-start'>
          <div className='flex gap-[40px]'>
            <span className='text-f-black-2'>{type == 'TRAINING' ? 'Training' : 'Validation'} Frame</span>
            <span className='flex gap-2'>
              <div className='flex align-items-center'>
                <RadioButton checked={datasource.type == 'HISTORICAL'} onChange={() => this.onChangeType('HISTORICAL')} />
                <label htmlFor='historical' className='ml-2'>
                  Historical
                </label>
              </div>
              <div className='flex align-items-center'>
                <RadioButton onChange={() => this.onChangeType('FILE')} checked={datasource.type == 'FILE'} />
                <label htmlFor='file' className='ml-2'>
                  File
                </label>
              </div>
            </span>
          </div>
          {datasource.type == 'FILE' && (
            <div>
              <FormicaSearchSelectBox
                options={this.getSeparatorOptions()}
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.chooseSeperator' })}
                value={(datasource as MLOpsDatasourceFile).separator}
                onChange={this.onChangeSeparator}
              />
            </div>
          )}
        </div>
        {this.getContent()}
      </div>
    );
  }

  private getContent = () => {
    const { datasource, aiModel, type, onChange } = this.props;
    switch (datasource.type) {
      case 'HISTORICAL':
        return (
          <MLOpsDatasourceHistoricalComponent
            key={type + (aiModel.aiModel.trainingDatasource == datasource) ? 1 : 0}
            type={type}
            aiModel={aiModel.aiModel}
            datasource={datasource as MLOpsDatasourceHistorical}
            onChange={(datasource: MLOpsDatasourceHistorical) => {
              onChange(datasource);
            }}
          />
        );
      case 'FILE':
        return <MLOpsDatasourceFileComponent type={type} datasource={datasource as MLOpsDatasourceFile} onChange={onChange} />;
      default:
        return <div>Unknown datasource type</div>;
    }
  };

  private onChangeType = (type: MLOpsDatasourceSchema['type']) => {
    const { onChange, datasource, page, changePageFilters } = this.props;
    Object.keys(datasource).forEach((key: string) => delete (datasource as any)[key]);
    datasource.type = type;
    if (type == 'HISTORICAL') {
      (datasource as MLOpsDatasourceHistorical).query = ValueFactory.initializeFilter();
      page.filters[this.props.type].filter = ValueFactory.initializeFilter();
      changePageFilters(page.filters);
    }
    onChange(datasource);
  };

  private getSeparatorOptions(): FormicaSelectBoxItem[] {
    return [
      {
        label: 'Comma',
        value: ',',
      },
      {
        label: 'Semicolon',
        value: ';',
      },
    ];
  }

  private onChangeSeparator = (e: FormicaSelectBoxItem) => {
    const { onChange, datasource } = this.props;
    if (datasource.type == 'FILE') {
      (datasource as MLOpsDatasourceFile).separator = e.value;
      onChange(datasource);
    }
  };
}

interface Props extends ReduxProps {
  datasource: MLOpsDatasourceSchema;
  type: 'VALIDATION' | 'TRAINING';
  onChange: (datasource: MLOpsDatasourceSchema, file?: File) => void;
}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel as AiModelState,
  page: state.page as PageState,
});
const mapDispatchToProps = { changePageFilters };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MlOpsDatasourceComponent);
